// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as V3RevealApi$LiteracyplanetTupperware from "./V3RevealApi.res.mjs";

function PilotClozeDragBucketDisplay(props) {
  var children = props.children;
  var match = V3RevealApi$LiteracyplanetTupperware.use();
  switch (match.reveal) {
    case "DontHideItems" :
    case "Hide" :
        break;
    case "RevealOneAtATime" :
        return React.createElement("div", {
                    className: "flex gap-4 items-center"
                  }, children);
    
  }
  return React.createElement("div", {
              className: "pilotClozeDragBucketDisplay"
            }, children);
}

var make = PilotClozeDragBucketDisplay;

var $$default = PilotClozeDragBucketDisplay;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
